import styled from "@emotion/styled";
import { colorVariables, fontWeights, gutterSizes } from "@gumtree/ui-library/src/base/theme";

const shouldForwardProp = (p: string) =>
    !["isOpen", "isSelected", "isSubCategoriesItems", "isVisible"].includes(p);

export const StyledCategoryName = styled("a", {
    shouldForwardProp,
})<{
    isSelected: boolean;
}>`
    width: 100%;
    margin: 0;
    font-weight: ${fontWeights.lightBold};

    &:hover {
        cursor: pointer;
    }

    ${(props) => `
        color: ${props.isSelected ? colorVariables.mainSecondary : colorVariables.mainTertiary};
    `};
`;

export const StyledAbundance = styled.span`
    margin-left: ${gutterSizes.large};
    color: ${colorVariables.textSecondary};
`;

export const StyledListViewSubCategories = styled("div", {
    shouldForwardProp,
})<{
    isSubCategoriesItems: boolean;
}>`
    display: flex;
    align-item: flex-end;
    flex-direction: column;
    padding-left: ${gutterSizes.xlarge};
    margin-top: ${gutterSizes.medium10};
    grid-gap: ${gutterSizes.base};

    ${({ isSubCategoriesItems }) => !isSubCategoriesItems && `margin: 0;`}
`;

export const StyledSubCategory = styled("div", {
    shouldForwardProp,
})<{
    isVisible: boolean;
}>`
    ${(props) => (props.isVisible ? "display: flex;" : "display: none;")};

    align-items: flex-end;
`;
